/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsUpdateSupplierProduct
 */
export interface MelcoModelsUpdateSupplierProduct {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUpdateSupplierProduct
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUpdateSupplierProduct
     */
    code?: string | null;
}

export function MelcoModelsUpdateSupplierProductFromJSON(json: any): MelcoModelsUpdateSupplierProduct {
    return MelcoModelsUpdateSupplierProductFromJSONTyped(json, false);
}

export function MelcoModelsUpdateSupplierProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsUpdateSupplierProduct {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'code': !exists(json, 'code') ? undefined : json['code'],
    };
}

export function MelcoModelsUpdateSupplierProductToJSON(value?: MelcoModelsUpdateSupplierProduct | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'code': value.code,
    };
}


